import { Component, HostBinding, Input, ChangeDetectionStrategy } from '@angular/core';

export type StateBoxState = 'success' | 'error' | 'info' | 'warning';

@Component({
    selector: 'app-state-box',
    templateUrl: './state-box.component.html',
    styleUrls: ['./state-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class StateBoxComponent {

    @HostBinding('class')
    @Input({ required: true }) state!: StateBoxState;

    constructor() {
    }
}
